import { Typography } from '@/components/primitives/Typography';
import { format } from '@/utils/dateTime';
import type { FC } from 'react';

interface LegDateProps {
  date?: string;
}

const LegDate: FC<LegDateProps> = ({ date }) => {
  if (!date) {
    return null;
  }

  return (
    <Typography variant="body2" className="text-neutral">
      {format(date, 'EEE, dd MMM yyyy')}
    </Typography>
  );
};

export default LegDate;
